/* tslint:disable:no-unused-expression */
/**
 * Will create a InputRange component
 * The InputRange can be personalized with the parameters below.
 *
 * @param     {number} value                    [The first value of the input, REQUIRED]
 * @param     {function} onChange               [The action when the value changes, REQUIRED]
 * @param     {boolean} showValue               [Will show the current value below tthe input: true or false]
 * @param     {number} min                      [The minimum value of the input]
 * @param     {number} max                      [The maximum value of the input]
 * @param     {function} handleChangeStart      [The action when the value start to change]
 * @param     {function} handleChangeComplete   [The action when the value has complete changed]
 *
 * Personalized style:
 * ------------------
 * For changing styles properties of the range-slider, there should be a CSS class named "range-slider-container"
 * with all the personalized CSS attributes
 */

/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import Slider from 'react-rangeslider'

/**
 *     Import
 *     - CSS
 */
import './styles/RangeInput.css'

/**
 * RangeInput class
 *
 * @class RangeInput
 * @extends {React.Component<any, any>}
 */
class RangeInput extends React.Component<any, any> {

    /**
     * Creates an instance of RangeInput.
     * @param {*} props
     * @param {*} context
     * @memberof RangeInput
     */
    constructor(props: any, context: any) {
        super(props, context)
        this.state = {
            value: props.value,
            showValue: props.showValue,
            min: props.min,
            max: props.max,
            onChange: props.onChange,
            handleChangeStart: props.handleChangeStart,
            handleChangeComplete: props.handleChangeComplete,
        }
    }

    /**
     * It handles the start of the change
     * and call the corresponding function from
     * the parent
     *
     * @memberof RangeInput
     */
    handleChangeStart = () => {
        (this.state.handleChangeStart) ? this.state.handleChangeStart() : null
    };

    /**
     * It handles the change of the input and call
     * the corresponding function from the parent
     *
     * @param   {any} value the changed value
     * @memberof RangeInput
     */
    handleChange = value => {
        this.setState({
            value: value,
        })
        this.state.onChange(value)
    };

    componentWillUpdate(nextProps: any) {
        if (nextProps !== this.props) {
            this.setState({ value: nextProps.value })
        }
    }

    /**
     * It handles the end of the change
     * and call the corresponding function from
     * the parent
     *
     * @memberof RangeInput
     */
    handleChangeComplete = () => {
        (this.state.handleChangeComplete) ? this.state.handleChangeComplete() : null
    };

    render() {
        const { value, showValue, min, max } = this.state
        return (
            <div className="range-slider-container">
                <Slider
                    min={min}
                    max={max}
                    value={value}
                    onChangeStart={this.handleChangeStart}
                    onChange={this.handleChange}
                    onChangeComplete={this.handleChangeComplete}
                />
                {(showValue) ? <div className="value">{value}</div> : null}
            </div>
        )
    }
}

export default RangeInput



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/RangeInput/RangeInput.tsx